'use client'

import { useEffect, useRef } from 'react'

export function MouseGlow() {
  const glowRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const isMobile = window.innerWidth <= 768
    if (isMobile) return

    const moveGlow = (e: MouseEvent) => {
      if (!glowRef.current) return
      
      const x = e.clientX
      const y = e.clientY
      
      glowRef.current.style.transform = `translate(${x}px, ${y}px)`
      glowRef.current.style.opacity = '1'
    }

    const hideGlow = () => {
      if (glowRef.current) {
        glowRef.current.style.opacity = '0'
      }
    }

    window.addEventListener('mousemove', moveGlow)
    document.addEventListener('mouseleave', hideGlow)

    return () => {
      window.removeEventListener('mousemove', moveGlow)
      document.removeEventListener('mouseleave', hideGlow)
    }
  }, [])

  return (
    <div 
      ref={glowRef}
      className="pointer-events-none fixed left-0 top-0 z-0 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand/10 opacity-0 mix-blend-screen blur-[100px] transition-opacity duration-500 hidden md:block"
      style={{ willChange: 'transform' }}
    />
  )
}
